@if (admissionsPerReason?.count! > 0) {
  <div id="divChart" class="chart-container">
    <canvas id="admissionPerReason"> </canvas>
  </div>
}
